export function getHasLoadedSlots({ listingId, loadedSlots }) {
  return loadedSlots.listingId === listingId
}
